// run-command-prompt-bootstrap-output-rules-section.ts — CLI 3.38.0-beta.2
// (dogfood chat-drive run 2, F-73).
//
// Two worker outputs the done path refuses kept appearing on survey/plan
// tickets: a survey returning entries in `proposed_tickets` (always `[]`), and
// a plan proposing a ticket with `executor: "controller"` (no v1 dispatch). The
// rules lived only in the pack, and 06c dropped a CLI line for golden I1's
// sake. Here they are a `## ` section with a FIXED title (golden I1 drops it by
// title, like E3/E15/E30) rendered for survey/plan tickets only. The adapter
// list comes from the same registry `ticketUnrunnableInV1Reason` reads.
import { COMMAND_ADAPTERS } from "./command-adapter.js";
import { BOOTSTRAP_TICKET_KINDS } from "./feature-dispatch-gate-guard.js";
import type { Ticket } from "./schemas/ticket-schema.js";

/** Fixed title — golden I1 filters on this string; rewording it changes the contract. */
export const BOOTSTRAP_OUTPUT_RULES_SECTION_TITLE =
  "## Ràng buộc output ticket survey/plan (BẮT BUỘC)";

/** `kind → adapter` pairs a plan may create: worker-run (executor claude), not bootstrap. */
export function dispatchableFeatureAdapterPairs(): string[] {
  return [...COMMAND_ADAPTERS.values()]
    .filter((a) => a.executor === "claude" && !BOOTSTRAP_TICKET_KINDS.includes(a.kind))
    .map((a) => `${a.kind} → ${a.id}`)
    .sort();
}

export function bootstrapOutputRules(ticket: Pick<Ticket, "kind">): string[] {
  if (!BOOTSTRAP_TICKET_KINDS.includes(ticket.kind)) return [];
  const lines = [
    "",
    BOOTSTRAP_OUTPUT_RULES_SECTION_TITLE,
    "- proposed_tickets: LUÔN là [] — controller không bao giờ áp field này; trả mục nào trong đó ⇒ kết luận done bị từ chối và attempt bị tính là một lần thất bại.",
  ];
  if (ticket.kind === "plan") {
    lines.push(
      `- Ticket tạo qua proposed_changes (op create): executor LUÔN "claude"; kind và command_adapter phải là một cặp trong: ${dispatchableFeatureAdapterPairs().join(", ")}. KHÔNG tạo ticket executor "controller", kind deploy/revert (deploy đi qua release flow + G3) hay survey/plan — ticket như vậy làm cả lô proposed_changes bị từ chối.`,
    );
  }
  return lines;
}
